import React, { useRef, useState, useLayoutEffect, useEffect } from 'react';
import useIsMobile from '../../Hooks/useIsMobile';
import Icon from '../IconBase/Icon';
import ProductCard from '../ProductCard/ProductCard';
import { withSize } from 'react-sizeme';
import(`./styles/${window.__litium.themeName}.scss`);

const roundUpNearest10 = (num) => {
  return Math.ceil(num / 10) * 10;
};

const ProductCarousel = ({ elements, title, url, urlTitle }) => {
  const itemsToScroll = 2;
  const productsRef = useRef();
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(true);
  const hasScroll = canScrollPrev || canScrollNext;
  const [currentSlide, setCurrentSlide] = useState(0);
  const isFirstSlide = () =>
    typeof productsRef.current !== 'undefined' &&
    productsRef.current.scrollLeft < 1;
  const isLastSlide = () =>
    typeof productsRef.current !== 'undefined' &&
    productsRef.current.scrollWidth <=
      productsRef.current.clientWidth + productsRef.current.scrollLeft;
  const next = () => {
    if (isLastSlide()) {
      return;
    }
    const scrollTo = currentSlide + itemsToScroll;
    if (scrollTo > elements.length) {
      productsRef.current.scrollTo({
        left: productsRef.current.children[elements.length].offsetLeft,
        behavior: 'smooth',
      });
    } else {
      productsRef.current.scrollTo({
        left: productsRef.current.children[scrollTo].offsetLeft,
        behavior: 'smooth',
      });
    }
  };
  const prev = () => {
    if (isFirstSlide()) {
      return;
    }
    const scrollTo = currentSlide - itemsToScroll;
    if (scrollTo <= 0) {
      productsRef.current.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      productsRef.current.scrollTo({
        left: productsRef.current.children[scrollTo].offsetLeft,
        behavior: 'smooth',
      });
    }
  };

  const onScroll = () => {
    setCanScrollPrev(!isFirstSlide());
    setCanScrollNext(!isLastSlide());
    for (let i = 0; i < productsRef.current.children.length - 1; i++) {
      const elm = productsRef.current.children[i];
      if (productsRef.current.scrollLeft <= roundUpNearest10(elm.offsetLeft)) {
        setCurrentSlide(i);
        break;
      }
    }
  };

  useEffect(() => {
    onScroll();
  });

  var isMobile = useIsMobile('medium');
  var showMoreLinkMobile = isMobile && url !== '' && urlTitle !== '';

  return (
    <div className="section product-carousel-block__section">
      <div
        className={`product-carousel-block__header ${
          hasScroll ? '' : 'product-carousel-block__header--no-scroll'
        }`}
      >
        <h3 className="product-carousel-block__title">{title}</h3>
        {!isMobile && (
          <a href={url} className="product-carousel-block__more-link">
            {urlTitle}
          </a>
        )}
        <div className="product-carousel-block__navigation">
          <div
            className={`product-carousel-block__button product-carousel-block__button--prev ${
              canScrollPrev ? '' : 'product-carousel-block__button--disabled'
            }`}
            onClick={prev}
          >
            <Icon iconCode="chevron_left" />
          </div>
          <div
            className={`product-carousel-block__button product-carousel-block__button--next ${
              canScrollNext ? '' : 'product-carousel-block__button--disabled'
            }`}
            onClick={next}
          >
            <Icon iconCode="chevron_right" />
          </div>
        </div>
      </div>
      <div
        className={`product-carousel-block__products ${
          hasScroll ? '' : 'product-carousel-block__products--no-scroll'
        } ${
          elements.length < 5
            ? 'product-carousel-block__products--wrapped-carousel'
            : ''
        }`}
        ref={productsRef}
        onScroll={onScroll}
      >
        {elements.map((elm, i) => (
          <ProductCard
            key={`carousel-card-${i}`}
            {...elm}
            forceWidth
            fromCarousel={elements.length < 5}
          />
        ))}
      </div>
      {showMoreLinkMobile && (
        <div className="product-carousel-block__more-link__wrapper">
          <a href={url} className="product-carousel-block__more-link">
            {urlTitle}
          </a>
        </div>
      )}
    </div>
  );
};

export default withSize()(ProductCarousel);
